import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { loginUser, clearError } from '../redux/slices/authSlice';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';
//import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import loginImage from '../../src/assets/images/all/login.png';
import '../../src/assets/css/bootstrap.min.css';
import '../../src/assets/css/fontawesome-all.min.css';
import '../../src/assets/css/slick.css';
import '../../src/assets/css/line-awesome.min.css';
// import '../../src/assets/css/main.css';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const email = searchParams.get('email');

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    if (password !== confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/reset-password`, {
        token,
        email,
        password,
        password_confirmation: confirmPassword,
      });

      setMessage(response.data.message);
    } catch (error) {
      setMessage("Something went wrong.");
    }
  };

  return (
    <section className="account d-flex" style={{ height: '100vh' }}>
      <div className="account__left d-none d-md-flex position-relative overflow-hidden">
        <img
          src={loginImage}
          alt="Login"
          className="account__img position-absolute w-100 h-100 object-cover"
        />
      </div>
      <div className="account__right pt-5 flx-align d-flex justify-content-center align-items-center">
              <div className="account-content">
                <h2 className="login-heading font-heading text-end mb-4">Forgot password</h2>
                <form onSubmit={handleSubmit}>
                <div className="row gy-3">
                <label htmlFor="email" className="form-label mb-2 font-18 font-heading fw-600">
                  New Password
                </label>
                  <input type="password" className="common-input common-input--bg" placeholder="New Password" value={password} onChange={(e) => setPassword(e.target.value)} required />

                  <label htmlFor="email" className="form-label mb-2 font-18 font-heading fw-600">
                    Confirm Password
                  </label>
                  <input type="password" className="common-input common-input--bg" placeholder="Confirm Password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
                  <button type="submit" className="btn btn-main btn-lg w-100 pill" >Reset Password</button>
                  </div>
                </form>
                {message && <p>{message}</p>}
      
                <div className="col-sm-12 mb-3 mt-3">
                  <p className="text font-14 text-center">Or</p>
                </div>
      
                <div className="col-sm-12 mt-3">
                <p className="text font-14 text-center">
                    <Link to="/login" className="link text-main text-decoration-underline fw-500">
                      Login
                    </Link>
                  </p>
                  <p className="text font-14 text-center">
                    <Link to="/register" className="link text-main text-decoration-underline fw-500">
                      Create Account
                    </Link>
                  </p>
                </div>
              </div>
            </div>
    </section>
  );
};

export default ResetPassword;
